<div class="members-page">
  <h2 class="members-page__header h1">Members Directory</h2>
  <div class="members-page__controls">
    <form [formGroup]="form" class="members-page__filters">
    <mat-form-field appearance="fill" class="filters-form-field">
      <mat-label>Search members</mat-label>
      <mat-icon matPrefix class="me-2">search</mat-icon>
      <input matInput [formControlName]="'name'" placeholder="Type to filter members...">
    </mat-form-field>
    @if (isManager) {
    <button (click)="openCreateUserDialog('0ms','0ms')" mat-flat-button>Create member</button>
    }
  </form>
</div>

@if (isManager) {
<button mat-flat-button (click)="openItemAnnihilatorDialog('0ms', '0ms')">Delete members</button>
}

<div class="members-page__grid">
  @for (group of groupedUsers; track group.letter) {
  <div class="members-page__letter-group">
    <div class="members-page__letter-header">{{group.letter}}</div>
    <div class="members-page__members-group">
      @for (user of group.users; track user.id) {
      <div class="members-page__member-card mat-elevation-z2">
        <div class="members-page__member-name">{{user.name}}</div>
        <div class="members-page__member-actions">
          @if (isManager) {
          <button mat-flat-button (click)="openUpdateUserDialog(user.id,'0ms','0ms')">Update</button>
          <button mat-flat-button (click)="deleteUser(user)">Delete</button>
          }
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
